import React, { useState, useEffect } from 'react';
import { useSearchParams } from "react-router-dom";
import {config} from "../shared/config";
import * as util from '../shared/commons';
import axios from "axios";
import 'primeicons/primeicons.css';
import { Col, Container, Row } from 'react-bootstrap';
import { Link, Navigate, useNavigate  } from 'react-router-dom';
import { Button } from 'primereact/button';
import ShowError from '../shared/ShowError';
import Laoding from '../shared/Laoding';


export default function ZarinpalVerifyPayment(props) {
    const navigate = useNavigate();
    const [redirectUrl, setRedirectUrl] = useState("");
    const [verifying, setVerifying] = useState(true);
    const [message, setMessage] = useState("");
    const [taxServiceLink, setTaxServiceLink] = useState("");
    const [searchParams] = useSearchParams();
    const Authority = searchParams.get("Authority");

    useEffect(() => {
        const storageKey = `verify_result_${Authority}`;
        const cached = localStorage.getItem(storageKey);
        console.log("verify result is>", cached);
        if (cached) {
            const data = JSON.parse(cached);
            setMessage(data.message);
            setVerifying(false);
            setTaxServiceLink(data.taxServiceLink);

            //localStorage.removeItem("verify_result");
            return;
        }
        localStorage.setItem(
            storageKey,
            JSON.stringify({ status: "pending" })
        );        
        
        setVerifying(true);
        var params = {
            authority:Authority 
        };
        var url = config.Server+`/payment/zarinpal/verify`;
        
        axios
        .post(url, params )
        .then(res => {
            let result = {
                message: "",
                taxServiceLink: "",
                status: "done"
            };            
            var response = res.data;
            if(response.state === "ok"){
                const msg = res.data.data;
                result.message = msg;
                setMessage(msg);

                var buy = util.getBuy();
                var osd = util.getOtherSystemDetail();
                console.log("buy is:", buy);
                console.log("osd is:", osd);
                if((osd != null)&&(buy.enName == "TaxService")){
                    if(osd.otherSystemIdentity!= ""){
                        result.taxServiceLink =  config.HanaAccUrl + "/Client/CheckContract?taxMemory=" + osd.otherSystemIdentity;
                        setTaxServiceLink(result.taxServiceLink);
                    }
                }
                util.deleteBuy();
                util.deleteBuyCompany();
                util.deleteBuyService();
                util.deleteOtherSystemDetail(); 
                
                localStorage.setItem(storageKey, JSON.stringify(result));
                document.location = config.Client + "/payment/show/result?Authority=" + Authority;
            }
            else{
                result.message = res.data.message;
                setMessage(result.message);
                localStorage.setItem(storageKey, JSON.stringify(result));
            }
            setVerifying(false);
        })
        .catch(err => {
            const result = {
                message: err.message,
                taxServiceLink: "",
                status: "error"
            };
            localStorage.setItem(storageKey, JSON.stringify(result));
            setMessage(err.message);
            setVerifying(false);
        });
    }, [Authority]);
    
    return(
        (redirectUrl != "")?
        <>
            <Navigate to={redirectUrl} replace={false}  />
        </>
        :
        (verifying === true)?
        <>
            <Row>
                <Col className="d-flex justify-content-center align-items-center" style={{height:"calc(100vh - 70px)"}}>
                    <Laoding showLable={true} label="در حال بررسی تراکنش پرداخت..." />
                </Col>
            </Row>
        </>
        :
        <>
            <Row>
                <Col className="d-flex justify-content-center align-items-center" style={{height:"calc(100vh - 70px)"}}>
                    <table style={{width:"100%", minWidth:"250px", marginLeft:"auto", marginRight:"auto"}}>
                        <tbody>
                            <tr>
                                <td style={{width:"100%", textAlign:"center"}}>
                                    <img src={require('../lib/images/hana.webp')} style={{width:"64px"}} />
                                    {/* <span style={{fontSize:"4em", textAlign:"center"}} className="pi pi-user"></span> */}
                                </td>
                            </tr>
                            <tr>
                                <td style={{fontSize:"1.5em", textAlign:"center"}}>{message}</td>
                            </tr>
                            <tr><td>&nbsp;</td></tr>
                            {
                                (util.getIpgTransactionType() == util.WallerTransactionTypes.BuyProduct)?
                            <tr>
                                <td style={{fontSize:"1em", textAlign:"center", direction:"ltr"}}>
                                    {
                                        taxServiceLink == ""?
                                        <Button severity="success" onClick={()=>{navigate('/my-contracts/list')}} style={{borderRadius:"5px"}}>&nbsp;&nbsp;مشاهده قراداد های من&nbsp;&nbsp;</Button>
                                        :
                                        <>
                                        جهت تکمیل فرایند بر رو لینک زیر کلیک نمائید
                                        <br/>
                                        <a 
                                            href={taxServiceLink} 
                                            style={{
                                            display: 'inline-block',
                                            padding: '10px 20px',
                                            backgroundColor: '#007bff',
                                            color: 'white',
                                            textDecoration: 'none',
                                            borderRadius: '5px'
                                            }}
                                        >
                                            فعالسازی مجوز در سامانه مودیان
                                        </a>
                                        </>
                                    }
                                    
                                    
                                </td>
                            </tr>
                                :(util.getIpgTransactionType() == util.WallerTransactionTypes.RecontinueContract)?
                            <tr>
                                <td style={{fontSize:"1em", textAlign:"center", direction:"ltr"}}>
                                    <Button severity="success" onClick={()=>{navigate('/my-contracts/list')}} style={{borderRadius:"5px"}}>&nbsp;&nbsp;مشاهده قراداد های من&nbsp;&nbsp;</Button>
                                    
                                </td>
                            </tr>
                                :(util.getIpgTransactionType() == util.WallerTransactionTypes.PromoteContractModule)?
                            <tr>
                                <td style={{fontSize:"1em", textAlign:"center", direction:"ltr"}}>
                                    <Button severity="success" onClick={()=>{navigate('/my-contracts/list')}} style={{borderRadius:"5px"}}>&nbsp;&nbsp;مشاهده قراداد های من&nbsp;&nbsp;</Button>
                                    
                                </td>
                            </tr>
                                :(util.getIpgTransactionType() == util.WallerTransactionTypes.PromoteContractParameter)?
                            <tr>
                                <td style={{fontSize:"1em", textAlign:"center", direction:"ltr"}}>
                                    <Button severity="success" onClick={()=>{navigate('/my-contracts/list')}} style={{borderRadius:"5px"}}>&nbsp;&nbsp;مشاهده قراداد های من&nbsp;&nbsp;</Button>
                                    
                                </td>
                            </tr>
                                :(util.getIpgTransactionType() == util.WallerTransactionTypes.IncreaseWalletAmount)?
                            <tr>
                                <td style={{fontSize:"1em", textAlign:"center", direction:"ltr"}}>
                                    <Button severity="success" onClick={()=>{navigate('/my-wallet/get')}} style={{borderRadius:"5px"}}>&nbsp;&nbsp;مشاهده کیف پول&nbsp;&nbsp;</Button>
                                    
                                </td>
                            </tr>
                            :
                            <tr>
                                <td style={{fontSize:"1em", textAlign:"center", direction:"ltr"}}>
                                    نوع تراکنش مشخص نمی باشد
                                    
                                </td>
                            </tr>

                            }
                            <tr><td>&nbsp;</td></tr>

                        </tbody>
                    </table>
                </Col>
            </Row>
        </>
    )
}